export default __webpack_public_path__ + "static/media/5.003fe1b8.jpg";